// 这个水印文件e-service与public-knowledge是相同的修改一处然后直接拷贝过去就行
// 这种水印并不安全，在脚本不断循环生成水印的条件下，
// 用户仍可以通过将dom节点复制到其他页面上展示，导致脚本无法运行，再手动除去水印。
const DEFAULT_ID = '__watermark__';

// 获得文本宽度
const getStringWidth = (str, styles) => {
  // 影响文字宽度的样式主要是font-size和font-weight，styles中没有这两个属性，则继承自body，结果可能产生误差
  if (!str || str.length <= 0) return 0;
  const $span = document.createElement('span');
  const $text = document.createTextNode(str);
  $span.append($text);
  const presetStyle = {
    whiteSpace: 'nowrap',
    lineHeight: '1',
    position: 'absolute',
    zIndex: '-1',
    opacity: '0',
    visibility: 'hidden',
  };
  const fullStyle = Object.assign({}, presetStyle, styles);
  Object.keys(fullStyle).forEach(styleKey => {
    $span.style[styleKey] = fullStyle[styleKey];
  });
  document.body.append($span);

  const width = $span.offsetWidth;
  $span.remove();
  return width;
};

// 水印配置
class WatermarkConfig {
  constructor({
    root = document.body, // 挂载节点
    watch = false, // 是否在定时重新生成,防止水印dom被同id dom替代、样式被篡改、被用户新建的父级元素隐藏等
    watchTime = 1500,
    mark = $t('水印'), // 水印文案
    domId = DEFAULT_ID, // dom元素id
    alpha = 1,
  } = {}) {
    this.root = root;
    this.watch = watch;
    this.watchTime = watchTime;
    this.mark = mark;
    this.domId = domId;
    this.alpha = alpha;
  }
}

const createCanvas = (mark, root, alpha) => {
  // 创建一个画布
  const can = document.createElement('canvas');
  // 字体大小
  const fontSize = 18;
  const style = { font: `${fontSize}px Vedana` };
  // 水印宽度
  const markLength = getStringWidth(mark, style) + fontSize;

  // 设置画布的长宽 (尽可能放下五行三列或更多)
  // 这种水印的放法还是有点问题，如果水印太长会导致水印行间距太大，一个页面放不来几行水印
  // 以后可以由原来的单行的水印修改为多行的水印（多个文本节点），然后用line-height来构建行间距
  const baseWidth = Math.min(root.offsetWidth * 0.3, 270);
  const baseHeight = Math.min(root.offsetHeight * 0.2, 270);
  can.width = Math.max(baseWidth, markLength);
  can.height = Math.max(baseHeight, markLength * 0.6);

  const cans = can.getContext('2d');
  //旋转角度
  cans.rotate((15 * Math.PI) / 180);
  cans.font = `${fontSize}px Vedana`;
  // 设置填充绘画的颜色、渐变或者模式
  cans.fillStyle = 'rgba(200, 200, 200, 0.40)';
  // 设置文本内容的当前对齐方式
  cans.textAlign = 'left';
  // 设置在绘制文本时使用的当前文本基线
  cans.textBaseline = 'Middle';
  cans.globalAlpha = alpha;
  // 在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
  cans.fillText(mark, fontSize, fontSize);
  return can;
};

const createDom = config => {
  const div = document.createElement('div');
  div.id = config.domId;
  // 让事件穿透dom（不支持ie）
  div.style.pointerEvents = 'none';
  div.style.top = '0px';
  div.style.bottom = '0px';
  div.style.left = '0px';
  div.style.right = '0px';
  div.style.position = 'absolute';
  div.style.zIndex = '100000';

  return div;
};

const mountedWatermark = (root, watermarkDom, canvas) => {
  watermarkDom.style.background = 'url(' + canvas.toDataURL('image/png') + ') left top repeat';
  const position = window.getComputedStyle(root).position;
  if (position === '' || position === 'static') {
    root.style.position = 'relative';
  }

  root.appendChild(watermarkDom);
};

// 水印类
const Watermark = {
  _config: {},
  _watermarkDom: {}, // 保存自己生成的dom
  createConfig: config => new WatermarkConfig(config),

  create(config = new WatermarkConfig()) {
    // 参数适配
    if (typeof config === 'string') {
      config = new WatermarkConfig({
        mark: config,
      });
    }
    this._create(config);
    config.watch && this.watch();
  },

  _create(config) {
    // 移除旧元素
    const oldDom = document.getElementById(config.domId);
    if (document.getElementById(config.domId) !== null) {
      oldDom.remove();
    }
    const canvas = createCanvas(config.mark, config.root, config.alpha);
    const dom = createDom(config);
    mountedWatermark(config.root, dom, canvas);

    this._config = config;
    this._watermarkDom = document.getElementById(config.domId);
    this._cssText = this._watermarkDom.style.cssText;
  },
  watch() {
    const me = this;
    if (!me._config.watch) {
      return;
    }
    setTimeout(() => {
      me._create(me._config);
      me.watch();
    }, me._config.watchTime);
  },
  destroy() {
    this._config.watch = false;
    this._config.root.removeChild(this._watermarkDom);
    this._config = {};
    this._watermarkDom = {};
  },
};
export default Watermark;
